import React from 'react';
import { StyledMessage, StyledIcon } from './index.styles.js';
export const FormMessage = ({ text, id, variant, className }) => (React.createElement(StyledMessage, { variant: variant, className: className, id: id },
    variant === 'error' && React.createElement(StyledIcon, { name: "caution", size: "xs" }),
    text));
//# sourceMappingURL=index.js.map